// extracted by mini-css-extract-plugin
export default {"amount":"payout_amount__9-Smr","confirmation-modal":"payout_confirmation-modal__ErYMb"};